import swal from "sweetalert";
import { BACKEND } from "../context/backend";

export function getProductosService(authTokens) {
  return fetch(BACKEND+"/api/productos/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function createProductoService(producto, authTokens) {
  const body = JSON.stringify(producto);

  return fetch(BACKEND+"/api/productos/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Nuevo producto creado!", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

export function updateProductoService(id, producto, authTokens) {
  const body = JSON.stringify(producto);
  return fetch(BACKEND+`/api/producto/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Producto editado", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

export function deleteProductoService(id, authTokens) {
  // Funcion que se encarga de eliminar a un producto pasandole su id.
  return fetch(BACKEND+`/api/producto/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}
